const riot = require('riot');

riot.tag2('page-debug', '<div class="f h-full"> <div class="overflow-scroll s-full"> <div class="container"> <div class="mb30" data-is="module-header"></div><a class="block rounded-8 border border-dark-012 overflow-hidden cursor-pointer mb20" href="{t(\'index.privacy_policy_link\')}" target="_blank"> <div class="bg-white border-dark-012 f fm flex-between px16 py10"> <div class="text-attention fw6">{t(⁗index.privacy_policy⁗)}</div><i class="icon-arrow_right text-dark-026 fs20"></i> </div></a> <div class="mb16"> <div>isNode: {spat.isNode}</div> <div>isBrowser: {spat.isBrowser}</div> </div> <div class="mb16"> <h2 class="mb16">言語設定</h2> <div class="mb8">現在の言語: {i18next.language}</div> <div class="f mb16"> <button class="button mx16" each="{lang in langs}" onclick="{changeLanguage}">{lang.t(\'debug.change_lang\', {lang: lang.lang})}</button> </div> <h3 class="mb8">テスト用文言</h3> <div>{t(\'debug.hello\')}</div> <div>{t(\'debug.count\', {count: 100})}</div> </div> <div class="mb16"><a class="p8" href="/debug/redirect">リダイレクトへのリンク</a></div> <div class="mb16"> <div data-is="module-note" note-id="1"></div> <div data-is="module-note" note-id="2"></div> <div data-is="module-note" note-id="3"></div> </div> <div class="p16"> <div class="s64 bg-red"></div> </div> <div class="mb16"><img src="/images/kenkyo.png"></div> <div class="mb16"> <ul class="ml32"> <li each="{item in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}">item {item}</li> </ul> </div> <div class="mb16"> <ul class="ml32"> <li each="{item in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}">item {item}</li> </ul> </div> <div class="mb16"> <ul class="ml32"> <li each="{item in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}">item {item}</li> </ul> </div> </div> </div> </div>', 'page-debug,[data-is="page-debug"]{display:block}', '', function(opts) {
    this.title = 'Hello, spat with parcel!';

    this.langs = ['ja', 'en', 'zh'].map(lang => {
      return {
        lang,

        t: i18next.getFixedT(lang),
      };
    });

    this.preload = async () => {
    };

    this.head = () => {
      return {
        title: 'aaaaaaa',
      };
    };

    this.on('show', async () => {
    });

    this.changeLanguage = (e) => {
      i18next.changeLanguage(e.item.lang.lang);
      spat.toast.message(t('debug.changed'));
    };
});